import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "rating rating--stars" }
const _hoisted_2 = { class: "rating__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stars, (star, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: _normalizeClass(["star", star])
      }, null, 2))
    }), 128)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.rating), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}